import { call, put, takeEvery } from "redux-saga/effects";
import { setAuth, setAuthError, setSystemError } from "./actions";
import { replace } from "connected-react-router";
import { links, API, LOGIN_LINK, SYSTEM_ERROR_LINK, PUBLIC_PATHS } from "@http";
import { UserDataTypes } from "./types";

function* checkAuthAction({ payload }: any) {
  try {
    const response = yield call(API, links.general.checkAuth);
    yield put(setAuth(response.data));
  } catch (error) {
    if (error !== 401) {
      yield put(setSystemError());
      yield put(replace(SYSTEM_ERROR_LINK));
      return;
    }

    yield put(setAuthError());
    const { path } = payload;
    if (PUBLIC_PATHS.includes(path)) return;
    yield put(replace(LOGIN_LINK));
  }
}

function* authenticationHandler({ payload }: any) {
  const URL = links.general.logIn + payload.path;
  yield (window.location.href = URL);
}

function* logoutHandler() {
  yield (window.location.href = links.general.logOut);
}

function* cleanSessionStorageHandler() {
  yield sessionStorage.clear();
}

export default function* userDataSaga() {
  yield takeEvery(UserDataTypes.AUTHENTICATE, authenticationHandler);
  yield takeEvery(UserDataTypes.AUTH_LOGOUT, logoutHandler);
  yield takeEvery(UserDataTypes.AUTH_CHECK, checkAuthAction);
  yield takeEvery(UserDataTypes.AUTH_ERROR, cleanSessionStorageHandler);
}
